import type { UserAnswersResponse, SurveyAnswer, UserJoint } from "@stss/types";
import { useTranslation } from "next-i18next";
import { useState } from "react";
import React from "react";

type UserAnswersProps = {
  loadAnswers: () => void;
  answers: null | UserAnswersResponse;
  label: string;
  currentJoint: UserJoint | undefined;
};

function UserAnswers({ loadAnswers, answers, label, currentJoint }: UserAnswersProps) {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const onclick = () => {
    if (!answers) {
      loadAnswers();
    } else {
      setCollapsed(!collapsed);
    }
  };

  return (
    <div
      className="mt-2 rounded-md border border-gray-700 p-0 p-1 text-sm dark:border-white"
      onClick={(event) => event.stopPropagation()}>
      <p className="text-blue-500">
        <span className="cursor-pointer" onClick={onclick}>
          {!answers ? `${t("load")} ${label}` : label}
        </span>
      </p>
      {answers && !collapsed && (
        <div>
          <div className="mt-2">
            {currentJoint ? (
              <div className="text-green-500">
                <span
                  className="mr-1 font-bold"
                  title={`${t("current")} ${t("joint")} (ID ${currentJoint.id})`}>
                  {t("joint")}:
                </span>
                <span title={currentJoint.description} className="mr-1">
                  {currentJoint.name}
                </span>
                <span title={t("joint") + " " + t("status")}>
                  ({t("status").toLowerCase() + " - " + currentJoint.statusDisplayName})
                </span>
              </div>
            ) : (
              <div className="text-orange-600">
                <span>{`${t("member_initiated_visit")}. ${t("no_current_program")}.`}</span>
              </div>
            )}
          </div>
          {Object.keys(answers).map((key: string) => {
            const arr = answers[key];
            const surveyID = Array.isArray(arr) ? arr[0]?.survey_id : null;
            return (
              <div className="mt-2" key={key}>
                {Array.isArray(arr) && arr.length > 0 ? (
                  <>
                    <p className="text-center">
                      <span className="font-medium capitalize">{key.replaceAll("_", " ")}</span>
                      {surveyID && <span className="ml-1">{`(survey id: ${surveyID})`}</span>}
                    </p>
                    <table className="mt-1 w-full text-sm">
                      <thead>
                        <tr className="border-b ">
                          <th className="text-left font-semibold">{t("question")}</th>
                          <th className="text-right font-semibold">{t("answer")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {answers[key].map((answer: SurveyAnswer, i: number) => (
                          <tr key={i}>
                            <th className="text-left font-normal">
                              <span>{answer.question}</span>
                            </th>
                            <th className="text-right font-normal">
                              <span>{answer.answer}</span>
                            </th>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <div className="mt-1 text-gray-700">{/* <p>{t("no_answers")}</p> */}</div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UserAnswers;
